import { Component } from '@angular/core';

@Component({
  selector: 'app-symcrypt',
  templateUrl: './symcrypt.component.html',
  styleUrl: '../../../../../../../../styles-tabelle-orari.css'
})
export class SymcryptComponent24 {

}
